import { useField } from 'formik';
import { usePlacesWidget } from 'react-google-autocomplete';

import FormField from 'components/common/FormField';

const addressComponentFormat = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'short_name',
  administrative_area_level_1: 'short_name',
  postal_code: 'short_name',
};

const getAddressComponent = (place, type) => {
  if (!place || !place.address_components) return '';

  let value = '';
  place.address_components.forEach(function (component) {
    if (component.types[0] === type) {
      value = component[addressComponentFormat[type]];
      return value;
    }
  });
  return value;
};

const AutocompleteGoogle = ({ setAddressDetails, ...props }) => {
  if (!process.env.GOOGLE_AUTOCOMPLETE_API_KEY || process.env.CYPRESS) {
    return <FormField {...field} {...props} />;
  }

  const [field] = useField(props.name);

  const { ref } = usePlacesWidget({
    apiKey: process.env.GOOGLE_AUTOCOMPLETE_API_KEY,
    options: { types: ['address'], componentRestrictions: { country: 'us' } },
    onPlaceSelected: place => {
      setAddressDetails({
        streetAddress:
          getAddressComponent(place, 'street_number') + ' ' + getAddressComponent(place, 'route'),
        city: getAddressComponent(place, 'locality'),
        state: getAddressComponent(place, 'administrative_area_level_1'),
        zipCode: getAddressComponent(place, 'postal_code'),
      });
    },
  });

  return <FormField innerRef={ref} {...field} {...props} />;
};

AutocompleteGoogle.propTypes = {
  setAddressDetails: PropTypes.func,
  name: PropTypes.string,
};

export default AutocompleteGoogle;
